import { render, staticRenderFns } from "./MongoViewEdit.vue?vue&type=template&id=2d9fe20a&scoped=true"
import script from "./MongoViewEdit.vue?vue&type=script&lang=ts"
export * from "./MongoViewEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9fe20a",
  null
  
)

export default component.exports